<mat-card>
  <mat-card-header>
    <div mat-card-avatar><i class="fa fa-list fa-2x"></i></div>
    <mat-card-title>{{ title }}</mat-card-title>
    <mat-card-subtitle>{{ subtitle }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content *ngIf="!resource.isLoading()">
    <ngx-crud-manager
        [clone]="true"
        [service]="discountService"
        [itemTemplate]="itemTemplate"
        [formTemplate]="formTemplate"
        [formGroup]="form"
    >
      <ng-template #itemTemplate let-item>
        <div class="row-wrapper">
          <span>{{item.name}}</span>
          <mat-icon
            [matTooltip]="item.active ? 'Activo' : 'Inactivo'"          
            [ngClass]="{
            'icon-success': item.active,
            'icon-error': !item.active
          }">
            circle
          </mat-icon>
        </div>
      </ng-template>
      <ng-template #formTemplate let-fform="form" let-value="value">
        <form [formGroup]="fform">
          <mat-form-field>
            <mat-label>Nombre del descuento</mat-label>
            <input matInput formControlName="name">
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'requirement_plural' | human | titlecase }} en las/los que aplicará el descuento</mat-label>
            <mat-select formControlName="requirement_ids" name="requirement_ids" autocomplete="off" [multiple]="true">
              <mat-option selectAll>
                Todos las/los {{ 'requirement_plural' | human }}
              </mat-option>
              @for (requirement of requirements(); track requirement.id) {
                <mat-option [value]="requirement.id">
                  {{requirement?.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Categorias a las que se aplicará el descuento</mat-label>
            <mat-select formControlName="category_ids" name="category_ids" autocomplete="off" [multiple]="true">
              <mat-option selectAll>
                Todas las categorías
              </mat-option>
              @for (category of categories(); track category.id) {
                <mat-option [value]="category.id">
                  {{category?.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Descuento (%)</mat-label>
            <input matInput type="number"
                            class="input-discount"
                            [min]="0"
                            [max]="100"
                            formControlName="discount_percent"
            >
            <div matSuffix>%</div>
          </mat-form-field>

          <div>
            <mat-label>Activo</mat-label>
            <mat-checkbox formControlName="active" />
          </div>
        </form>
      </ng-template>
    </ngx-crud-manager>
  </mat-card-content>
</mat-card>
